import { Stepper } from "@mantine/core";
import { useTheme } from "../../ThemeContext";

export const StyledStepper = (props) => {

    const { theme } = useTheme();
    return (
        <Stepper
            styles={{
                steps: {
                    alignItems: 'flex-start',
                },
                step: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 10,
                    zIndex: 2
                },
                stepIcon: {
                    height: '5rem',
                    width: '5rem',
                    borderWidth: 4,
                    alignSelf: 'center',
                    borderRadius: '50%',
                    borderColor: '#392ed6 !important',
                    background: 'transparent !important',
                },
                stepBody: {
                    margin: '10px 0px',
                    overflow: 'visible',
                },
                stepLabel: {
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    fontSize: '1.6rem',
                    color: theme === 'dark' ? '#9aa1a7' : '#000000DE',

                },
                separator: {
                    marginLeft: -2,
                    marginRight: -2,
                    height: 4,
                    transform: 'translateY(21px)',
                    zIndex: 1,
                },
                separatorActive: {
                    backgroundColor: '#3121B2'
                },
                stepCompletedIcon: {
                    backgroundColor: '#3121B2',
                    borderColor: '#3121B2',
                    borderWidth: 4,
                    borderRadius: '50%',
                }
            }}
            {...props}
        />
    );
}